module.exports = __webpack_public_path__ + "static/proxy-349dfdbff2073e862a283688fc03f94a.png";